import { useNavigate } from "react-router-dom";
import Button from "../../commons/Button/Button";
import Typography from "../../commons/Typography/Typography";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-center h-screen bg-light-grey-1">
      <div className="bg-white shadow-md rounded-lg p-50 flex flex-col items-center text-center max-w-lg">
        <div className="mb-32">
          <Typography color="primary" size="2xl" weight="bold" className="leading-none">
            404
          </Typography>
        </div>

        <Typography color="dark-grey" size="lg" weight="semibold" className="mb-14">
          Page Not Found
        </Typography>

        <Typography color="dark-grey" size="sm" weight="normal" className="mb-32 px-20">
          The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
        </Typography>

        <div className="flex flex-row gap-4">
          <Button
            type="secondary"
            border
            width="186"
            height="44"
            onClick={() => navigate(-1)}
          >
            Go Back
          </Button>

          <Button
            type="main"
            border
            width="186"
            height="44"
            onClick={() => navigate("/sub-users")}
          >
            Go to Dashboard
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
